import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import { Contents, ContentHeading } from "../styles";
import styled from "styled-components";
import { ButtonCommonTheme, Tip } from "modules/theme";

const Responsive = styled.div`
  .sidebar {
    flex: 0 0 auto;
    overflow: hidden;
    position: relative;
  }

  .sidebar-bg-image {
    overflow: auto;
    background-color: #f9f9f9;
  }
  .sidebar-bg-image:before {
    position: absolute;
    background-image: url("/images/new/slidebar-bg.png");
    z-index: 0;
    content: "";
    bottom: 0px;
    right: 0px;
    background-repeat: no-repeat;
    background-position: bottom right;
    width: 100%;
    height: 100%;
  }

  height: 100%;

  .reverse {
    flex-direction: row-reverse;
  }

  .heading {
    max-width: 85%;
    overflow: hidden;
    text-overflow: ellipsis;
    > h6 {
      margin-left: 0 !important;
    }
  }

  // REMOVING FOR FULL SCREEN ISSUES
  // .main-container{
  // 	margin-top: 70px !important;
  // }

  .leftrightheadercontainer {
    margin-left: 70px;
  }

  .filter-btn {
    position: relative;
    right: 0px !important;
    top: 3px !important;
    padding: 12px 20px !important;
  }

  .max-height-header {
    max-height: 100vh;
  }

  // for livemonitor
  // .paddig-bottom-header{
  // 	padding-bottom: 5rem!important;
  // }

  .content {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    flex: 0 0 auto;
    background: #fff;
    padding: 0;
  }

  .responsive-sidebar {
    width: 25%;
  }

  .responsive-content {
    width: 75%;
  }

  .chart-wrapper {
    flex: 0 0 auto;
    width: 50%;
  }

  .header {
    // REMOVING FOR FULLSCREEN ISSUES
    // position: absolute;
    position: relative;
    top: 0;
    z-index: 999;
    width: 100%;
    background: #fff;
  }

  .label-filter {
    width: 100%;
    position: relative;
  }

  @media only screen and (max-width: 1300px) {
    .responsive-sidebar {
      width: 32%;
    }

    .responsive-content {
      width: 68%;
    }

    .chart-wrapper {
      width: 100%;
    }
  }

  @media only screen and (max-width: 1005px) {
    .responsive-sidebar {
      width: 35%;
    }

    .responsive-content {
      width: 65%;
    }
  }

  @media only screen and (max-width: 872px) {
    .heading {
      > h6 {
        margin-left: 10px !important;
        margin-top: 0px !important;
        font-size: 36px !important;
      }
    }

    .main-container {
      overflow: auto;
      // REMOVING FOR FULL SCREEN ISSUES
      // margin-top: 70px !important
    }

    .max-height-header {
      max-height: 100%;
    }

    .content {
      padding-left: 15px !important;
      padding-right: 15px !important;
      padding-top: 15px;
      padding-bottom: 75px;
      height: auto;
      overflow: auto;
    }
    .chart-wrapper-row {
      // margin: 0 10px !important;
      // margin-bottom: 60px !important;
    }
  }

  @media only screen and (max-width: 560px) {
    .heading {
      > h6 {
        font-size: 24px !important;
      }
    }
  }
`;

const TabButton = styled.button`
  // background-color: ${(props) => (props.isActive ? "#28a6de" : "#f4fbfd")}; /* Active tab background */
  background: none;
  color: ${(props) => (props.isActive ? "#2B3C93" : "#a8aaab")}; /* Active tab text color */
  padding: 10px;
  border: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 22px;
  line-height: 20px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 6px 12px;
  border-radius: 10px;
  transition: background-color 0.3s ease;
  margin-right: 15px;

  // &:hover {
  //   background-color: #ddd;
  // }
`;

function AdminDashboardWrapper({
  heading,
  sidebar,
  filterOnClick,
  right,
  tabData = false,
  content,
  header,
  allowFullScreen = false,
  isFullScreen = false,
  chatSidebar,
  chatContent,
  chatEventCall,
  changeFullScreen = () => { },
}) {
  const [isMediumScreen, setisMediumScreen] = useState(false);
  const [isChatMediumScreen, setChatisMediumScreen] = useState(false);
  const [fullScreenTip, setFullScreenTip] = useState("Enter");
  const [activeTab, setActiveTab] = useState("call");

  useEffect(() => {
    const toggleIconAndFullScreenState = () => {
      if (!document.fullscreenElement) {
        document.getElementById("full-screen-toggle-button").innerText =
          "fullscreen";
        changeFullScreen(false);
        setFullScreenTip("Enter");
      } else if (document.fullscreenElement) {
        document.getElementById("full-screen-toggle-button").innerText =
          "fullscreen_exit";
        changeFullScreen(true);
        setFullScreenTip("Exit");
      }
    };
    if (allowFullScreen) {
      document.addEventListener(
        "fullscreenchange",
        toggleIconAndFullScreenState
      );
    }
    const handleWindowResize = () => {
      if (window.innerWidth <= 875) {
        setisMediumScreen(true);
        setChatisMediumScreen(true);
      } else {
        setisMediumScreen(false);
        setChatisMediumScreen(false);
      }
    };
    handleWindowResize();

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
      if (allowFullScreen) {
        document.removeEventListener(
          "fullscreenchange",
          toggleIconAndFullScreenState
        );
      }
    };
  }, []);

  const getFilter = () => {
    return (
      <div className={`label-filter`}>
        <ContentHeading className="heading d-flex px-3">
          {heading}
          {allowFullScreen && (
            <Tip text={fullScreenTip + " Fullscreen"}>
              <button
                id="full-screen-toggle-button"
                style={{ backgroundColor: "#0000" }}
                onClick={(e) => toggleFullScreen(e)}
                className="material-symbols-outlined border-0"
              >
                {document.fullscreenElement ? "fullscreen_exit" : "fullscreen"}
              </button>
            </Tip>
          )}
        </ContentHeading>
        {isFullScreen === false && filterOnClick && (
          <ButtonCommonTheme
            type="filter"
            className="filter-btn"
            filterOnClick={filterOnClick}
          />
        )}
      </div>
    );
  };

  const getFilters = () => {
    return (
      <div className={`label-filter`}>
        <ContentHeading className="heading d-flex" style={{ minHeight: '0px', margin: '0' }}>
          {/* {heading} */}
          {allowFullScreen && (
            <Tip text={fullScreenTip + " Full-Screen"}>
              <button
                id="full-screen-toggle-button"
                style={{ backgroundColor: "#0000" }}
                onClick={(e) => toggleFullScreen(e)}
                className="material-symbols-outlined border-0"
              >
                {document.fullscreenElement ? "fullscreen_exit" : "fullscreen"}
              </button>
            </Tip>
          )}
        </ContentHeading>
        {isFullScreen === false && filterOnClick && (
          <ButtonCommonTheme
            type="filter"
            className="filter-btn"
            filterOnClick={filterOnClick}
          />
        )}
      </div>
    );
  };

  function toggleFullScreen(e) {
    if (allowFullScreen) {
      let fse = window.document.getElementById(
        "admin-dashboard-toggle-fullscreen"
      );
      if (fse && !document.fullscreenElement) {
        fse.requestFullscreen();
      } else if (document.fullscreenElement === fse) {
        document.exitFullscreen();
      }
    }
  }

  return (
    <Responsive>
      <Contents className="p-0" marginLeft="70">
        <div className="header">{header}</div>
        {tabData && <div className="tabs d-flex align-items-center" style={{ padding: '16px', whiteSpace: 'nowrap' }}>
          <TabButton
            onClick={() => setActiveTab("call")}
            isActive={activeTab === "call"} // Conditional styling
          >
            Call Livemonitor
          </TabButton>
          <TabButton
            onClick={() => {
              setActiveTab("chat");
              chatEventCall();
            }}
            isActive={activeTab === "chat"} // Conditional styling
          >
            Chat Livemonitor
          </TabButton>
          {getFilters()}
        </div>}

        {activeTab === "call" && <div
          id="admin-dashboard-toggle-fullscreen"
          className={`row w-100 h-100 m-0 main-container ${right ? "reverse" : ""
            }`}
          style={{
            maxHeight: "calc(100vh - 57px)",
            background: "#fff",
          }}
        >
          {sidebar && (
            <div
              className={`max-height-header sidebar p-0 ${isMediumScreen ? "w-100" : "responsive-sidebar"
                }`}
              style={{ height: "100%" }}
            >
              <div className="sidebar-bg-image h-100">
                {/* {isMediumScreen && getFilter()} */}
                {sidebar}

                {isMediumScreen && <div className="content">{content}</div>}
              </div>
            </div>
          )}
          {!isMediumScreen && (
            <div
              className={`max-height-header ${sidebar ? "responsive-content paddig-bottom-header" : "w-100"
                } content`} tabDatatabData
            >
              {tabData ? "" : getFilter()}
              {content}
            </div>
          )}
        </div>}

        {activeTab === "chat" && <div
          id="admin-dashboard-toggle-fullscreen"
          className={`row w-100 h-100 m-0 main-container ${right ? "reverse" : ""
            }`}
          style={{
            maxHeight: "calc(100vh - 57px)",
            background: "#fff",
          }}
        >
          {chatSidebar && (
            <div
              className={`max-height-header sidebar p-0 ${isChatMediumScreen ? "w-100" : "responsive-sidebar"
                }`}
              style={{ height: "100%" }}
            >
              <div className="sidebar-bg-image h-100">
                {/* {isMediumScreen && getFilters()} */}
                {chatSidebar}

                {/* {isChatMediumScreen && <div className="content">{chatContent}</div>} */}
                <div style={{ display: isChatMediumScreen ? "block" : "none" }} className="content">{chatContent}</div>
              </div>
            </div>
          )}
          {/* {!isChatMediumScreen && ( */}
          <div
            className={`max-height-header ${sidebar ? "responsive-content paddig-bottom-header" : "w-100"
              } content`}
            style={{
              display: !isChatMediumScreen ? "block" : "none", // Hide instead of unmount
            }}
          >
            {/* {getFilter()} */}
            {chatContent}
          </div>
          {/* )} */}
        </div>}

      </Contents>
    </Responsive>
  );
}

export default AdminDashboardWrapper;

AdminDashboardWrapper.Header = Header;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/AdminDashboardWrapper.js